/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';
import DateRangePicker from '../contexts/CustomDatePicker';
import CustomDataGrid from '../contexts/CustomDataGrid';

const columns = [
  { field: 'Shipdate', headerName: 'Ship Date', width: 300, type: 'Date', headerAlign: 'left', align: 'left' },
  { field: 'SKU', headerName: 'SKU', width: 300, headerAlign: 'left', align: 'left' },
  { field: 'Part_Number', headerName: 'Part Number', width: 300, headerAlign: 'left', align: 'left' },
  { field: 'Part_Description', headerName: 'Part Description', width: 300, headerAlign: 'left', align: 'left' },
  { field: 'Qty', headerName: 'Quantity', width: 300, type: 'number', headerAlign: 'left', align: 'left' },
];

const EbayShipping = () => {
  const strt = new Date(new Date(new Date().getTime()).setMonth(new Date().getMonth() - 1));
  const end = new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1));
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(strt);
  const [endDate, setEndDate] = useState(end);
  const [tableData, setTableData] = useState([]);
  const { activeMenu, themeSettings } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        InboundTable();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(strt); // for compulsory dates
      setEndDate(end); // for compulsory dates
    }
  }, [startDate, endDate]);

  const InboundTable = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({
      UserId: JSON.parse(localStorage.getItem('loginID')) === null || undefined ? null : JSON.parse(localStorage.getItem('loginID')).UserId,
      ProcessName: 'SimpliSafePortal',
      PageName: 'Ebay shipping history',
      FromDate: startDate,
      ToDate: endDate,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(`${variables.BASE_URL}EbayShippingHistory`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (JSON.parse(result)?.IsSuccess !== false && JSON.parse(result)?.IsAuthorize !== false) {
          setTableData(JSON.parse(result)?.EbayShippingHistory);
        } else if (JSON.parse(result)?.IsSuccess !== true && JSON.parse(result)?.IsAuthorize) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData([]);
        } else if (JSON.parse(result)?.IsAuthorize !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Access Denied!',
            });
            navigate('/');
          }, 0);
        }
        setLoading(false);
      });
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend').focus();
    }
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();
  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id">
          <Navbar />
          <DateRangePicker
            loading={loading}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            disableFutureDates={disableFutureDates}
            TransferIntakeTable={InboundTable}
          />
        </div>
        <div>
          {themeSettings}
          <div className="container-fluid">
            <div id="table_container">
              <Paper className="table_backpaper">
                {loading ? (
                  <LoadingOverlay />
                ) : (
                  <Box className="table_positions">
                    <CustomDataGrid
                      name="Ebay Shipping"
                      tableData={tableData}
                      column={columns}
                    />
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-30px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Box>
                )}
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EbayShipping;
